import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Navbar from "../../../atoms/navbar";

import {
    Layout,
    Alert,
    Collapse,
    Form,
    AutoComplete,
    Input,
    Row,
    Col,
    Select,
    Checkbox,
    Button,
    message,
    Radio,
    Modal,
} from "antd";
import { Block, Confirm, Loading, Report } from "notiflix";
import ItemList from "../ItemList";
import Vendor from "../Vendor";
import VendorList from "../VendorList";
import VendorFinalisation from "../VendorFinalisation";
import Approval from "../Approval";
import { use } from "react";
import { QuestionOutlined, DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";
import { loginRequest } from "../../../config/api.config";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

export default function CreateBidding() {
    const [form] = Form.useForm();
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [hasInitialized, setHasInitialized] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [NewVendorName, setNewVendorName] = useState('');
    const [NewQuotationNumber, setNewQuotationNumber] = useState('');
    const [vendorSelected, setVendorSelected] = useState([]);
    const [biddingHdr, setBiddingHdr] = useState([]);
    const [approval, setApproval] = useState([]);
    const [userBranch, setUserBranch] = useState([]);
    const { instance, accounts } = useMsal();
    const [fileList, setFileList] = useState({});
    const [vendorErp, setVendorErp] = useState([]);
    const [idRecord, setIdRecord] = useState('');
    const [currentSession, setCurrentSession] = useState(
        JSON.parse(localStorage.getItem("session_signin"))
    );
    const isAuthenticated = useIsAuthenticated();

    let navigate = useNavigate();

    let { id } = useParams();

    const inisialVendors = []
    const InitialItems = []
    const InitialBiddingHdr = {
        description: "",
        req_num: "",
        selectedVendor: "",
        vendorValue: "",
        buyer_id: "",
        buyer_name: "",
        additional_information: "",
    }
    // const getUsersBranch = async () => {
    //     try {
    //         const { data: employees } = await API.getEmployeeTalentaByBranch(
    //             HeaderFarms(null),
    //             48274
    //         );

    //         return employees;
    //     } catch (error) {
    //         console.error("Error in getEmployeeTalentaByBranch:", error);
    //     }
    // }

    const getVendor = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);

            const { data } = await API.VendorCapex(headers);
            setVendorErp(data);
        } catch (error) {
            console.error(error);
        } finally {
            Loading.remove();
        }
    };

    const getUsersBranch = async () => {
        try {
            const request = {
                ...loginRequest,
                account: accounts[0],
            };
            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            const response = await API.UserBranchID(headers, '0, 48274');
            if (response.code == 200) {
                setUserBranch(response.data);
            }
            setApproval(InitialApproval)
        } catch (error) {
            console.error("Error in getEmployeeTalentaByBranch:", error);
            return [];
        }
    }

    const getDetailBidding = async () => {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };
        const responseToken = await instance.acquireTokenSilent(request).catch(e => {
            console.error("Token acquisition failed", e);
            throw e;
        });
        const accessToken = responseToken.accessToken;
        const headers = HeaderFarms(accessToken);

        const response = await API.BiddingDetail(headers, id);
        if (response.code === 200) {
            const data = await response.data;
            const updateItems = data.biddingItem.map(item => ({
                ...item,
                name: item.item_name
            }))

            const updateVendors = data.biddingVendor.map(vendor => ({
                ...vendor,
                name: vendor.vendor_name,
                contact: vendor.telp,
            }))

            setBiddingHdr(data.biddingHdr);
            setItems(updateItems);
            setVendors(updateVendors);
            form.setFieldsValue({
                vendors_discount_price: updateVendors.map(v => v.discount_price) || [],
                vendors_payment_: updateVendors.map(v => v.payment_method) || [],
                vendors_franco_: updateVendors.map(v => v.franco) || [],
                vendors_warranty_: updateVendors.map(v => v.warranty) || [],
                vendors_duration_: updateVendors.map(v => v.payment_term) || [],
                vendors_description_: updateVendors.map(v => v.information) || [],
                vendors_tax_: updateVendors.map(v => v.tax) || [],
                selected_vendor: data.biddingHdr.vendor_selected,
                selected_vendor_value: data.biddingHdr.value,
                vendor_additional_info: data.biddingHdr.comments,
                vendors_currency_: updateVendors.map(v => v.currency) || [],
            })
        } else {
            console.error("Error fetching bidding details:", response.statusText);
        }
    }

    const handleApprovalChange = (index, value) => {
        const updatedApproval = [...approval];
        updatedApproval[index].employee_id = value;
        setApproval(updatedApproval);
        console.log("Updated Approval", updatedApproval);
    }

    const InitialApproval = [
        { position: "Approval", employee_id: "" },
    ]

    const showModal = () => {
        console.log("show modal")
        setIsModalOpen(true);
        getVendor();
    };

    const handleOnChangeVendorSelected = (value) => {
        const selectedVendor = vendors.find(v => v.id === value);
        setVendorSelected(selectedVendor);
    }

    const addItem = () => {
        const newItem = {
            id: items.length + 1,
            name: ``,
            qty: 0,
            uom: '',
        };
        setItems([...items, newItem]);
        setHasInitialized(false);
    }

    const addApproval = () => {
        const newApproval = {
            position: "Approval",
            employee_id: "",
        };
        setApproval([...approval, newApproval]);
    }

    const removeItem = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        console.log(updatedItems, "updatedItems");
        console.log(items, "items");
        setItems(updatedItems);
        setHasInitialized(false);
    }

    function handleOnchangeItem(index, field, value) {
        const updatedItems = [...items];
        updatedItems[index][field] = value;
        setItems(updatedItems);
        setHasInitialized(false);
    }

    function handleOnchangeItemPrice(vendorIndex, itemIndex, field, value) {

        const updatedVendors = [...vendors];
        updatedVendors[vendorIndex].items[itemIndex][field] = value;
        updatedVendors[vendorIndex].items[itemIndex]['total_price'] = updatedVendors[vendorIndex].items[itemIndex]['qty'] * updatedVendors[vendorIndex].items[itemIndex]['price_after'];

        console.log("updatedVendors", updatedVendors);
        setVendors(updatedVendors);
        countTotalPrice(vendorIndex);
    }

    function countTotalPrice(vendorIndex) {
        const updatedVendors = [...vendors];
        let total_price = 0;
        let discount_price = 0;
        let tax_price = 0;
        let tax = updatedVendors[vendorIndex].tax
        let discount = updatedVendors[vendorIndex].discount

        updatedVendors[vendorIndex].items.forEach(item => {
            total_price += item.price_after * item.qty;
        });

        tax_price = (total_price * tax) / 100;
        discount_price = updatedVendors[vendorIndex].discount_price;

        updatedVendors[vendorIndex].total_price = total_price;
        updatedVendors[vendorIndex].tax_price = tax_price;
        updatedVendors[vendorIndex].grand_total = total_price + tax_price - discount_price;
    }

    const handleSaveAddVendor = () => {

        const vendorIndex = vendorErp.findIndex(
            vendor => vendor.Name.toLowerCase() === NewVendorName.toLowerCase()
        );

        let vendorQuotation = '-';
        if (NewQuotationNumber !== '') {
            vendorQuotation = NewQuotationNumber;
        }

        if (vendorIndex > -1) {
            const newVendor = {
                id: vendors.length + 1,
                name: NewVendorName,
                quotation_number: vendorQuotation,
                address: "",
                contact: "",
                pic: "",
                discount: 0,
                payment: "",
                franco: "",
                warranty: "",
                duration: "",
                description: "",
                total_price: 0,
                tax: 0,
                tax_price: 0,
                grand_total: 0,
                discount_price: 0,
                grand_total: 0,
                items: items.map(item => ({
                    ...item,
                    price_before: 0,
                    price_after: 0,
                    total_price: 0,
                }))
            };
            setVendors([...vendors, newVendor]);
            setIsModalOpen(false);
            setNewVendorName('');
            setNewQuotationNumber('');
        }
        else {
            const newVendor = {
                id: vendors.length + 1,
                name: NewVendorName,
                quotation_number: vendorQuotation,
                address: "",
                contact: "",
                pic: "",
                discount: 0,
                payment: "",
                franco: "",
                warranty: "",
                duration: "",
                description: "",
                total_price: 0,
                tax: 0,
                tax_price: 0,
                grand_total: 0,
                discount_price: 0,
                grand_total: 0,
                items: items.map(item => ({
                    ...item,
                    price_before: 0,
                    price_after: 0,
                    total_price: 0,
                }))
            };
            setVendors([...vendors, newVendor]);
            setIsModalOpen(false);
            setNewVendorName('');
            setNewQuotationNumber('');
        }

    }

    function deleteVendor(index) {
        const updatedVendors = [...vendors];
        updatedVendors.splice(index, 1);
        setVendors(updatedVendors);
    }

    function handleOnchangeVendor(index, field, value) {

        const updatedVendors = [...vendors];
        updatedVendors[index][field] = value;
        console.log("updatedVendors", updatedVendors)

        setVendors(updatedVendors);
        countTotalPrice(index)
    }

    function removeApproval(index) {
        const updatedApproval = approval.filter((_, i) => i !== index);
        setApproval(updatedApproval);
    }

    const handleOnchangeBiddingHdr = (field, value) => {
        const updatedBiddingHdr = { ...biddingHdr };
        updatedBiddingHdr[field] = value;
        setBiddingHdr(updatedBiddingHdr);
    }

    const onFinish = async (values) => {
        try {
            Loading.dots("Processing your request...");
            console.log("onFinish values", values);
            const updateBiddingHdr = {
                description: values.description,
                req_number: values.Req_num,
                selectedVendor: vendorSelected?.name || "",
                vendorValue: values.selected_vendor_value,
                additional_information: values.vendor_additional_info,
                buyer_id: currentSession.nik,
                buyer_name: currentSession.fullname,
            }

            const base64Files = await Promise.all(
                (values.attachment || []).map((file) => {
                    return new Promise((resolve) => {
                        if (file.base64) {
                            resolve({ name: file.name, base64: file.base64 });
                        } else if (file.originFileObj) {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                resolve({ name: file.name, base64: e.target.result });
                            };
                            reader.readAsDataURL(file.originFileObj);
                        } else {
                            resolve(null);
                        }
                    });
                })
            );

            const data = {
                updateBiddingHdr: { ...updateBiddingHdr },
                updateItems: [...items],
                updateVendors: [...vendors],
                updateApproval: [...approval],
                values: values, // optional: include raw files if needed
                attachment: base64Files.filter(file => file !== null), // filter out null values
            };

            const request = {
                ...loginRequest,
                account: accounts[0],
            };

            const responseToken = await instance.acquireTokenSilent(request).catch(e => {
                console.error("Token acquisition failed", e);
                Loading.remove();
                throw e;
            });
            const accessToken = responseToken.accessToken;

            const headers = HeaderFarms(accessToken);
            await API.CreateBidding(
                headers,
                data
            );
            Report.success(
                "Your response has been recorded.",
                "Thank you",
                "Okay",
                function () {
                    Loading.remove();
                    navigate("/bidding/history");
                }
            );


        } catch (error) {
            Loading.remove();
            console.error("Error in onFinish:", error);

            let errorMessage = "Terjadi kesalahan.";

            if (error.errors && Array.isArray(error.errors)) {
                errorMessage = error.errors.map((e, idx) => `Error [${idx + 1}]: ${e.message || e}`).join('\n');
                error.errors.forEach((e, idx) => {
                    console.error(`Error [${idx}]:`, e);
                });
            } else if (error.message) {
                errorMessage = error.message;
            }

            Report.warning(
                "Error",
                errorMessage,
                "Okay"
            );

        }

    }

    useEffect(() => {
        setItems(InitialItems)
        setVendors(inisialVendors)
        setBiddingHdr(InitialBiddingHdr)
        setApproval(InitialApproval)
        getUsersBranch()
        if (id) {
            getDetailBidding();
        }
    }, [id])

    function RequestToken() {
        const request = {
            ...loginRequest,
            account: accounts[0],
        };

        instance
            .acquireTokenSilent(request)
            .then((response) => {
                if (!currentSession) {
                    getUser(response.accessToken);
                }

            })
            .catch((e) => {
                handleLogin(instance);
                console.error(e);
            });
    }

    function handleLogin(instance) {
        instance
            .loginRedirect(loginRequest)
            .then(() => { })
            .catch((e) => {
                console.error(e);
            });
    }

    async function getUser(token) {
        try {
            let user = await API.getUserCredential(HeaderFarms(token), {
                access_token: token,
            });
            setCurrentSession(user);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!hasInitialized && items.length && vendors.length) {
            const updatedVendors = vendors.map(vendor => ({
                ...vendor,
                items: items.map(item => ({
                    ...item,
                    price_before: 0,
                    price_after: 0,
                    total_price: 0,
                }))
            }));
            setVendors(updatedVendors);
            setHasInitialized(true);
        }
        if (vendorSelected?.grand_total) {
            form.setFieldsValue({ selected_vendor_value: vendorSelected.grand_total });
        }
    }, [items, hasInitialized, vendors, vendorSelected])

    useEffect(() => {

        if (!isAuthenticated) {
            RequestToken();
        } else {
            if (instance.getAllAccounts().length > 0) {
                instance.setActiveAccount(accounts[0]);
                RequestToken();

            } else {
                handleLogin(instance);
            }
        }
    })

    const { Panel } = Collapse;
    const { TextArea } = Input
    return (
        <>
            <Navbar
                title="Create"
                back={true}
                subtitle="Bidding"
                navigate="/bidding/history"
            ></Navbar>
            <div className="container-fluid white-back-cr">
                <Form
                    form={form}
                    scrollToFirstError={true}
                    name="service_request_form"
                    encType="multipart/form-data"
                    onFinish={onFinish}
                    autoComplete="off"
                    size="middle"
                    layout="vertical"
                    initialValues={{ items }}
                >
                    <div className="container p-3" style={{ alignSelf: "center" }}>
                        <div className="row">
                            <div className="col-md-12">
                                <Collapse
                                    className="collapse_sr"
                                    expandIconPosition={"end"}
                                    bordered={true}
                                    defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                >
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Summary</b>}
                                        key="1"
                                    >
                                        <Row gutter={10} className="mb-1">
                                            <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }} >
                                                <Form.Item
                                                    label="Description"
                                                    name="description"
                                                    rules={[{ required: true, message: "Please enter" }]}
                                                >
                                                    <TextArea rows={4} onChange={(e) => handleOnchangeBiddingHdr("description", e.target.value)} />
                                                </Form.Item>
                                            </Col >
                                            <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                                                <Form.Item
                                                    label="Req Number"
                                                    name="Req_num"
                                                    rules={[
                                                        { required: true, message: "Please input Req Number" },
                                                    ]}
                                                >
                                                    <Input onChange={(e) => handleOnchangeBiddingHdr("req_number", e.target.value)}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Items</b>}
                                        key="2"
                                    >
                                        <ItemList items={items} handleOnchangeItem={handleOnchangeItem} removeItem={removeItem} />
                                        <div className="d-flex justify-content-center mt-3">
                                            <button onClick={addItem} type="button" className="btn btn-primary W-100 btn-sm">Add Item</button>
                                        </div>
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Vendor</b>}
                                        key="3"
                                    >
                                        {vendors.length > 0 && <VendorList
                                            vendors={vendors}
                                            handleOnchangeItemPrice={handleOnchangeItemPrice}
                                            handleOnchangeVendor={handleOnchangeVendor}
                                            deleteVendor={deleteVendor}
                                            form={form}
                                        />}
                                        <div className="d-flex justify-content-center mt-3">
                                            <button type="button" className="btn btn-primary W-100" onClick={showModal}>Add Vendor</button>
                                        </div>
                                        {isModalOpen && (
                                            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                                <div className="modal-dialog" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Tambah Vendor</h5>
                                                            <button type="button" className="close" onClick={() => setIsModalOpen(false)}>
                                                                <span>&times;</span>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <div className="form-group">
                                                                <label>Nama Vendor</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    list="vendor-list"
                                                                    onChange={(e) => setNewVendorName(e.target.value)}
                                                                />
                                                                <datalist id="vendor-list">
                                                                    {vendorErp.map((v, index) => (
                                                                        <option key={index} value={v.Name} />
                                                                    ))}
                                                                </datalist>
                                                            </div>
                                                            <div className="form-group mt-2">
                                                                <label>Nomor Quotation</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    onChange={(e) => setNewQuotationNumber(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>
                                                                Cancel
                                                            </button>
                                                            <button type="button" className="btn btn-primary" onClick={handleSaveAddVendor}>
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </Panel>

                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Vendor Finalisation</b>}
                                        key="3">
                                        <VendorFinalisation vendors={vendors} vendorSelected={vendorSelected} handleOnChangeVendorSelected={handleOnChangeVendorSelected} handleOnchangeBiddingHdr={handleOnchangeBiddingHdr} />
                                    </Panel>
                                    <Panel
                                        style={{ background: "#fce8b6" }}
                                        header={<b>Approval</b>}
                                        key="3"
                                    >
                                        <Approval users={userBranch} handleApprovalChange={handleApprovalChange} approval={approval} removeApproval={removeApproval} />
                                        <div className="d-flex justify-content-center mt-3">
                                            <button onClick={addApproval} type="button" className="btn btn-primary W-100 btn-sm">Add approval</button>
                                            <Button
                                                type="button"
                                                button
                                                icon={<ReloadOutlined/>}
                                                onClick={getUsersBranch}
                                                className="ms-3"
                                            />
                                        </div>
                                    </Panel>

                                </Collapse>
                                <div style={{ display: 'flex', justifyContent: 'center', gap: "30px" }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        className="btn btn-primary btn-block mt-3"
                                        style={{ width: "50%" }}
                                    >
                                        Submit
                                    </Button>

                                    {/* <Button
                                        type="button"
                                        htmlType="submit"
                                        className="btn btn-light btn-block mt-3"
                                        style={{ width: "50%" }}
                                    >
                                        Save as Draft
                                    </Button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    );
}